import React from 'react';
import { observer } from 'mobx-react';
import CourseListService from '../services/CourseListService';
import CourseListFilter from './CourseListFilter';

const CourseListFilterContainer = () => (
  <CourseListFilter
    values={CourseListService.form.getValues()}
    onChange={CourseListService.form.setValue}
    onSearch={CourseListService.load}
  />
);

export default observer(CourseListFilterContainer);
